import { Building2, Users, Handshake, FileText, UserSearch, UserRound, ClipboardList, Package } from './icons';

/**
 * Canonical icon for each entity type — use these everywhere for consistency.
 */
export const entityIcons = {
  supplier: Building2,
  contact: Users,
  mandate: Handshake,
  deal: Handshake, // backwards compat alias
  candidate: UserRound,
  proposition: FileText,
  requirement: ClipboardList,
  candidateRequirement: UserSearch,
  deliverableRequirement: Package,
} as const;
